import { render, staticRenderFns } from "./CustomImageUpload.vue?vue&type=template&id=aa0512ba&scoped=true"
import script from "./CustomImageUpload.vue?vue&type=script&lang=js"
export * from "./CustomImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomImageUpload.vue?vue&type=style&index=0&id=aa0512ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0512ba",
  null
  
)

export default component.exports